import { render, staticRenderFns } from "./ViewAllocation.vue?vue&type=template&id=75a9f31c&scoped=true"
import script from "./ViewAllocation.vue?vue&type=script&lang=js"
export * from "./ViewAllocation.vue?vue&type=script&lang=js"
import style0 from "./ViewAllocation.vue?vue&type=style&index=0&id=75a9f31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a9f31c",
  null
  
)

export default component.exports